import { render, staticRenderFns } from "./milestone-cell.vue?vue&type=template&id=7ed38020&scoped=true&"
import script from "./milestone-cell.vue?vue&type=script&lang=ts&"
export * from "./milestone-cell.vue?vue&type=script&lang=ts&"
import style0 from "./milestone-cell.vue?vue&type=style&index=0&id=7ed38020&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ed38020",
  null
  
)

export default component.exports